import { inject, ref } from 'vue';
import { defineStore } from 'pinia';

export const useStore = defineStore('store', () => {
    const currentPage = ref("REQUESTOR");
    const currentTypePage = ref(0);

    const progressPage = ref(0);
    const progressTypePage = ref(-1);

    const culture = inject("culture");

    // use this key for testing on localhost: 6LcItiEUAAAAADP7rp9UlLlUGTIO73HJpevuXOAf
    const recaptchaSiteKey = inject("recaptchaSiteKey");

    const submitUrl = inject("submitUrl");

    const ackBox = ref(false);

    const formData = {
        FirstName: "",
        LastName: "",
        Organization: "",
        PhoneNumber: "",
        Email: "",
        ForGovernment: null,
        ForMedia: null,
        ForLegal: null,
        Types: [],
        Police: {
            CaseNumber: "",
            PersonInvolvedName: "",
            PersonInvolvedDob: "",
            PersonInvolvedRelation: "",
            IncidentDate: "",
            IncidentTime: "",
            IncidentLocation: "",
            Details: ""
        },
        Emergency: {
            Types: [],
            IncidentDateTime: "",
            IncidentRelationship: "",
            Details: ""
        },
        Cctv: {
            CaseNumber: "",
            Location: "",
            IncidentDate: "",
            IncidentTime: "",
            Details: "",
            Reason: ""
        },
        Bodycam: {
            CaseNumber: "",
            IncidentDate: "",
            IncidentTime: "",
            IncidentDescription: "",
            Reason: ""
        },
        Medical: {
            PatientName: "",
            IncidentDate: "",
            IncidentTime: "",
            IncidentLocation: "",
            AssistanceLocation: ""
        },
        Access: {
            BadgeholderName: "",
            BadgeNumber: "",
            Upid: "",
            DatesAndTimes: "",
            Details: ""
        },
        Contract: {
            RequestNumber: "",
            ProjectTitle: "",
            RequestedRecords: [],
            OtherRecordType: ""
        },
        Other: {
            Details: ""
        }
    };

    const errors = {
        AnyError: false,
        FirstName: false,
        LastName: false,
        PhoneNumber: false,
        Email: false,
        ForGovernment: false,
        ForMedia: false,
        ForLegal: false,
        Types: false,
        Police: {
            PersonInvolvedName: false,
            PersonInvolvedDob: false,
            PersonInvolvedRelation: false,
            IncidentDate: false,
            IncidentLocation: false,
            Details: false

        },
        Emergency: {
            Types: false,
            IncidentDateTime: false,
            IncidentRelationship: false,
            Details: false
        },
        Cctv: {
            Location: false,
            IncidentDate: false,
            IncidentTime: false,
            Details: false,
            Reason: false
        },
        Bodycam: {
            IncidentDate: false,
            IncidentTime: false,
            IncidentDescription: false,
            Reason: false
        },
        Medical: {
            PatientName: false,
            IncidentDate: false,
            IncidentTime: false,
            IncidentLocation: false
        },
        Access: {
            BadgeholderName: false,
            BadgeNumber: false,
            Upid: false,
            DatesAndTimes: false,
            Details: false
        },
        Contract: {
            ProjectTitle: false,
            RequestedRecords: false
        },
        Other: {
            Details: false
        }
    };

    const lexicon = ["en", "es"];

    lexicon["en"] = {
        AnswerRequired: "Answer is Required.",
        Back: "Back",
        Next: "Next",
        No: "No",
        PRFormRequestBkg: "Request Background",
        PRFormRequestBkg1: "Are you requesting records on behalf of a local, state, or federal government agency?",
        PRFormRequestBkg5: "Are you a member of the news media?",
        PRFormRequestBkg8a: "Are you requesting records as a representative of, or a party to, a lawsuit in which the Port is a party, or are you requesting records relating to a tort claim notice filed with the Port of Portland?",
        PRRequestHead: "Request Public Records",
        PRFormPage1: "Your Information",
        PRFormPage2: "Background",
        PRFormPage3: "Record Types",
        PRFormPage4: "Review & Finish",
        PRFormRequestorInfo: "Requestor Information",
        PRFormName: "First Name",
        PRFormName2: "First Name is Required.",
        PRFormName3: "Last Name",
        PRFormName4: "Last Name is Required.",
        PRFormOrg: "Organization",
        PRFormPhone: "Phone Number",
        PRFormPhone1: "Example: 5035551212",
        PRFormPhone2: "Phone Number must be a ten-digit number with area code.",
        PRFormEmail: "Email",
        PRFormEmail2: "Email is Required and Must be a Properly Formatted Email Address.",
        PRFormRequestType1: "Request Type",
        PRFormRequestType2: "Check the boxes for the types of records you are looking for:",
        PRFormRequestType3: "Police reports",
        PRFormRequestType4: "Emergency and airport communications (e.g. Computer Aided Dispatch (CAD) reports, Police or Fire radio audio)",
        PRFormRequestType5: "CCTV recordings",
        PRFormRequestType6: "Law enforcement officer body worn camera recordings",
        PRFormRequestType7: "Medical, injury or incident reports",
        PRFormRequestType8: "Facility access control records (e.g. badge swipe reports)",
        PRFormRequestType9: "Procurement documentation (e.g. solicitation documents; evaluation materials; awarded contracts)",
        PRFormRequestType10: "All other record requests",
        PRFormRequestType11: "At least one Record Type is Required.",
        PRPolice1: "Port of Portland Police Report Request Detail",
        PRPolice2: "Please note that unless you identify as someone requesting records on behalf of a government agency, all records released are subject to redactions.",
        PRPolice3: "Port of Portland Case Number (if known):",
        PRPolice3a: "Name of the person involved:",
        PRPolice4: "Name of the Person Involved is Required.",
        PRPolice5: "Date of Birth of the person involved:",
        PRPolice6: "DOB of the Person Involved is Required.",
        PRPolice7: "Your relation to the person involved:",
        PRPolice8: "Relation to the Person Involved is Required.",
        PRPolice9: "Date of Incident:",
        PRPolice10: "Date of Incident is Required.",
        PRPolice11: "Time of Incident (HH:MM AM/PM, or Morning, Afternoon, Evening, etc.):",
        PRPolice12: "General Location of Incident:",
        PRPolice13: "Location of Incident is Required.",
        PRPolice14: "Details of the request (type of incident, vehicle make and model involved, items stolen, etc.)",
        PRPolice15: "Details of Incident is Required.",
        PRFormEmergency7: "Types of Records Requested:",
        PRFormEmergency8: "Emergency Communications Request Detail",
        PRFormEmergency8a: "Computer Aided Dispatch (CAD) Report",
        PRFormEmergency9: "Airport Communications Telephone",
        PRFormEmergency10: "Police Radio Audio",
        PRFormEmergency11: "Fire Radio Audio",
        PRFormEmergency13: "Date and approximate time of incident:",
        PRFormEmergency14: "Incident Date and Time is Required.",
        PRFormEmergency15: "Requester's relationship to the incident:",
        PRFormEmergency16: "Relationship to Incident is Required.",
        PRFormEmergency17: "Incident Description and Location:",
        PRFormEmergency18: "Incident Description and Location:",
        PTCCTV: "CCTV Request Detail",
        PTCCTV1: "Please provide as much detail as possible in the form below to assist with locating the requested records. Failure to do so may delay the process or increase the cost of the records requested. Per the State of Oregon Retention Requirements, CCTV footage is retained for 30 days before it is destroyed.",
        PTCCTV2: "Port of Portland Case Number (if known):",
        PTCCTV3: "Location (gate number, concourse, arrivals or departure roadway):",
        PTCCTV4: "Location of Incident is Required.",
        PTCCTV5: "Date of incident (video over 30 days may no longer be retrievable):",
        PTCCTV6: "Date of Incident is Required.",
        PTCCTV7: "Time of the incident: (HH:MM AM/PM)",
        PTCCTV8: "Time of Incident is Required.",
        PTCCTV9: "Detailed description of incident (include: make, model, and color of cars; descriptions of individuals involved, including clothing or baggage):",
        PTCCTV11: "What is the reason for the request and how do you intend to utilize the video recording?",
        PTCCTV12: "Reason for Request is Required.",
        PRBodyCam1: "Law Enforcement Body Worn Camera Request Detail",
        PRBodyCam2: "ORS 192.345(40)(b) states that a request for disclosure under this subsection must identify the approximate date and time of the incident for which the records are requested and be reasonably tailored to include only that material for which a public interest requires disclosure.",
        PRBodyCam3: "Port of Portland Case Number (if known):",
        PRBodyCam4: "Date of Incident:",
        PRBodyCam5: "Date of Incident is Required.",
        PRBodyCam5a: "Approximate time of incident: (HH:MM AM/PM)",
        PRBodyCam7: "Incident Description:",
        PRBodyCam8: "Incident Description is Required.",
        PRBodyCam9: "ORS 192.345(40)(b) exempts all body camera footage from a law enforcement officer unless the public interest requires disclosure in the particular instance.",
        PRBodyCam10: "State the public interest requiring disclosure:",
        PRBodyCam11: "Reason Requiring Disclosure is Required.",
        PRFormMedical1: "Medical Incident Reports Request Detail",
        PRFormMedical2: "Name of the patient:",
        PRFormMedical3: "Name of Patient is Required.",
        PRFormMedical6: "Time of the incident: (HH:MM AM/PM)",
        PRFormMedical8: "Location of the incident:",
        PRFormMedical10: "Location where the assistance was provided if different from above:",
        PRFormBadge: "Facility Access Control Records / Badge Swipe Reports",
        PRFormBadge1: "Please submit a separate records request for each individual badge holder report that is needed. Failure to do so may delay the process or increase the cost of the records requested.",
        PRFormBadge2: "Badge Holder Full Name:",
        PRFormBadge3: "Badge holders name is Required.",
        PRFormBadge4: "Badge Number:",
        PRFormBadge5: "Badge Number is Required.",
        PRFormBadge6: "(on the upper backside of a PDX security badge)",
        PRFormBadge7: "UPID is Required.",
        PRFormBadge8: "Date Range and Timeframe of Needed Data:",
        PRFormBadge9: "Dates and Times are Required.",
        PRFormBadge10: "What is the reason for your request?",
        PRFormBadge11: "Answer is Required.",
        PRContracts: "Contracts & Procurement Request Detail",
        PRContracts1: "Please visit:",
        PRContracts2: "to find the Request for Proposal/Request for Qualification (RFP/RFQ) for your request.",
        PRContracts3: "RFP or RFQ Number: (separate with commas if multiple RFPs or RFQs requested)",
        PRContracts4: "Project Title:",
        PRContracts5: "Project Title is Required.",
        PRContracts6: "Requested Records:",
        PRContracts7: "All Proposals/Bids (includes SBE or DBE forms)",
        PRContracts8: "Winning Proposals/Bids (includes SBE or DBE forms)",
        PRContracts9: "Scoring & Evaluation & Notes",
        PRContracts10: "Related Task Orders/Purchase Orders",
        PRContracts11: "Awarded Contract",
        PROther: "All Other Records Requests Detail",
        PROther1: "Describe the record(s) you are requesting. Please provide as much detail as possible such as date or timeframe, author, keywords, title or subject matter of the records.",
        PROther2: "Request Details are Required.",
        PRFormReview: "Review your Request",
        PRFormReview1: "Request Information",
        PRFormReview7: "For Government:",
        PRFormReview8: "For Media:",
        PRFormReview9: "For Legal:",
        PRFormReview10: "Port of Portland Police Report Request Detail",
        PRFormReview11: "Case Number:",
        PRFormReview12: "Name of Person Involved:",
        PRFormReview13: "Date of Birth of Person Involved:",
        PRFormReview14: "Relation to Person Involved:",
        PRFormReview16: "Time of Incident:",
        PRFormReview18: "Details:",
        PRFormReview19: "Emergency Communications Request Detail",
        PRFormReview20: "Types:",
        PRFormReview21: "Date and Time of Incident:",
        PRFormReview23: "Relationship to Incident:",
        PRFormReview24: "CCTV Request Detail",
        PRFormReview30: "Reason:",
        PRFormReview31: "Law Enforcement Body Worn Camera Request Detail",
        PRFormReview37: "Medical Incident Reports Request Detail",
        PRFormReview38: "Name of Patient:",
        PRFormReview42: "Location of Assistance:",
        PRFormReview43: "Facility Access Control Records / Badge Swipe Reports",
        PRFormReview45: "Name of Badgeholder:",
        PRFormReview46: "Dates and Times:",
        PRFormReview47: "Badge Number:",
        PRFormReview48: "Contracts & Procurement Request Detail",
        PRFormReview49: "Request Number:",
        PRFormReview50: "Project Titles:",
        PRFormReview51: "Requested Records:",
        PRFormReview52: "All Other Records Requests Detail",
        PRFormReview54: "Terms and Conditions",
        PRFormReview55: "Pursuant to ORS 192.324, requesters are responsible for paying fees which are reasonably calculated to reimburse the Port for the actual cost of making the requested records available. These costs may include the cost of searching, locating and copying records; reviewing records to redact exempt material; supervising the inspection of records; certifying records; and mailing records. Fees will be charged even if no records are located or if the Port determines that the requested records are exempt from disclosure.",
        PRFormReview56: "You may view the Port’s Public Records Request Price List (fee schedule) by",
        PRFormReview57: "clicking here",
        PRFormReview58: "A Port Records Program representative will advise you of the cost to provide the requested records and will require your approval before beginning to gather them.",
        PRFormReview59: "CLICKING THE BOX BELOW REPRESENTS YOUR AGREEMENT TO COMPLY WITH THESE TERMS AND CONDITIONS, including agreement to pay the cost of fulfilling this public records request.",
        PRFormReview60: "I agree to these terms and conditions.",
        PRFormReview61: "There is at least one error on the previous pages that must be fixed before submitting this request.",
        PRFormNav22: "Submit",
        PRFormSubmitted: "Request Submitted",
        PRFormSubmitted1: "Your request has been successfully submitted. You will receive a verification email shortly.",
        PRFormSubmitted2: "You must verify your email address by clicking on the VERIFY REQUEST button contained in that email.",
        PRFormSubmitted3: "No further consideration for your request will be granted until you verify your request.",
        Yes: "Yes",
    };

    lexicon["es"] = {
        AnswerRequired: "Es Obligatoria su Respuesta.",
        Back: "Atrás",
        Next: "Siguiente",
        No: "No",
        PRFormRequestBkg: "Solicitud de Antecedentes",
        PRFormRequestBkg1: "¿Está usted solicitando registros en nombre de una agencia gubernamental local, estatal o federal?",
        PRFormRequestBkg5: "¿Es usted miembro de los medios de comunicación?",
        PRFormRequestBkg8a: "¿Está usted solicitando registros como representante o como parte de una demanda en la que el Puerto es parte, o está usted solicitando registros relacionados con un aviso de reclamación por agravio presentado ante el Puerto de Portland?",
        PRRequestHead: "Solicite Registros Públicos",
        PRFormPage1: "Su Información",
        PRFormPage2: "Antecedentes",
        PRFormPage3: "Tipos de Registros",
        PRFormPage4: "Revise y Finalice",
        PRFormRequestorInfo: "Información del Solicitante",
        PRFormName: "Nombre de Pila",
        PRFormName2: "Es obligatorio Poner su Nombre de Pila.",
        PRFormName3: "Apellido Paterno",
        PRFormName4: "Es Obligatorio Poner El Apellido Paterno.",
        PRFormOrg: "Organización",
        PRFormPhone: "Número de Teléfono",
        PRFormPhone1: "Ejemplo: 5035551212",
        PRFormPhone2: "El Número de teléfono debe ser un número de diez dígitos con el código de área.",
        PRFormEmail: "Correo Electrónico",
        PRFormEmail2: "El Correo Electrónico es Obligatorio y Debe Ser una Dirección de Correo Electrónico con el Formato Adecuado.",
        PRFormRequestType1: "Tipo de Solicitud",
        PRFormRequestType2: "Marque los cuadritos de los tipos de registros que usted está buscando:",
        PRFormRequestType3: "Informes de la Policía",
        PRFormRequestType4: "Comunicaciones de emergencia y del aeropuerto (por ejemplo, Informes de Despacho Asistido por Computadora (CAD, siglas en inglés), Audio de Radio de la Policía o de los Bomberos)",
        PRFormRequestType5: "Grabaciones de circuito cerrado de televisión (CCTV, siglas en inglés)",
        PRFormRequestType6: "Grabaciones de cámara portada en el cuerpo de un agente de la ley",
        PRFormRequestType7: "Informes médicos, de lesiones o de incidentes.",
        PRFormRequestType8: "Registros de control de acceso a las instalaciones (por ejemplo, informes de pase con tarjetas)",
        PRFormRequestType9: "Documentación de adquisiciones (por ejemplo, documentos de solicitación; materiales de evaluación; contratos adjudicados)",
        PRFormRequestType10: "Todas las demás solicitudes de registros",
        PRFormRequestType11: "Se requiere al menos un tipo de registro.",
        PRPolice1: "Detalles de la Solicitud de Informe de la Policía del Puerto de Portland",
        PRPolice2: "Tenga usted en cuenta que, a menos que se identifique como alguien que solicita registros en nombre de una agencia gubernamental, todos los registros publicados están sujetos a redacciones.",
        PRPolice3: "Número de Caso del Puerto de Portland (si se conoce):",
        PRPolice3a: "Nombre de la persona involucrada:",
        PRPolice4: "Es obligatorio poner el nombre de la persona involucrada.",
        PRPolice5: "Fecha de Nacimiento de la persona involucrada:",
        PRPolice6: "Es obligatorio poner la fecha de nacimiento de la persona involucrada.",
        PRPolice7: "Su relación con la persona involucrada:",
        PRPolice8: "Es obligatorio que usted tenga relación con la persona involucrada.",
        PRPolice9: "Fecha del Incidente:",
        PRPolice10: "Es obligatorio poner la fecha del incidente.",
        PRPolice11: "Hora del Incidente (HH:MM AM/PM, o mañana, Tarde, Noche, etc.):",
        PRPolice12: "Ubicación general del incidente:",
        PRPolice13: "Es obligatorio poner la ubicación del incidente.",
        PRPolice14: "Detalles de la solicitud (tipo de incidente, marca y modelo del vehículo involucrado, artículos robados, etc.)",
        PRPolice15: "Se requieren detalles del incidente.",
        PRFormEmergency7: "Tipos de Registros Solicitados:",
        PRFormEmergency8: "Detalle de la Solicitud de Comunicaciones de e\Emergencia",
        PRFormEmergency8a: "Informe de Envío Asistido por Computadora (CAD, siglas en inglés)",
        PRFormEmergency9: "Teléfono de Comunicaciones del Aeropuerto",
        PRFormEmergency10: "Audio de Radio de la Policía",
        PRFormEmergency11: "Audio de Radio de los Bomberos",
        PRFormEmergency13: "Fecha y hora aproximada del incidente:",
        PRFormEmergency14: "Se requiere la fecha y la hora del incidente.",
        PRFormEmergency15: "Relación del solicitante con el incidente:",
        PRFormEmergency16: "Se requiere poner la relación con el incidente.",
        PRFormEmergency17: "Descripción y Ubicación del Incidente:",
        PRFormEmergency18: "Se requiere poner la descripción y ubicación del incidente.",
        PTCCTV: "Detalle de solicitud de CCTV",
        PTCCTV1: "Proporcione por favor tantos detalles como le sea posible en el siguiente formulario para ayudar a localizar los registros solicitados. De no hacerlo se podría retrasar el proceso o aumentar el costo de los registros solicitados. Según los requisitos de retención del estado de Oregon, las imágenes de CCTV se conservan durante 30 días antes de que sean destruidas.",
        PTCCTV2: "Número de caso del Puerto de Portland (si se conoce):",
        PTCCTV3: "Ubicación (número de sala, recibidor, vía de llegada o de salida):",
        PTCCTV4: "Se Requiere Poner la Ubicación del Incidente.",
        PTCCTV5: "Fecha del incidente (es posible que el video de más de 30 días ya no se pueda recuperar):",
        PTCCTV6: "Se requiere poner la fecha del incidente.",
        PTCCTV7: "Hora del incidente: (HH:MM AM/PM)",
        PTCCTV8: "Se Requiere Poner la Hora del Incidente.",
        PTCCTV9: "Descripción detallada del incidente (incluya: marca, modelo y color de los automóviles; descripciones de las personas involucradas, incluida la ropa o el equipaje):",
        PTCCTV11: "¿Cuál es el motivo de la solicitud y cómo piensa usted usar la grabación del vídeo?",
        PTCCTV12: "Se requiere poner el motivo de la solicitud.",
        PRBodyCam1: "Detalle de Solicitud de la Cámara Corporal Usada por las Fuerzas del Orden",
        PRBodyCam2: "La Ley de Oregon ORS 192.345(40)(b) establece que en cada solicitud de divulgación conforme a esta subsección se debe identificar fecha y hora aproximadas del incidente para el cual se solicitan los registros y adaptarse razonablemente para incluir solo ese material cuya divulgación la requiere el interés público.",
        PRBodyCam3: "Número de Caso del Puerto de Portland (si se conoce):",
        PRBodyCam4: "Fecha del Incidente:",
        PRBodyCam5: "Se requiere poner la Fecha del Incidente.",
        PRBodyCam5a: "Hora Aproximada del Incidente: (HH:MM AM/PM)",
        PRBodyCam7: "Descripción del Incidente:",
        PRBodyCam8: "Se Requiere Poner una Descripción del Incidente.",
        PRBodyCam9: "La Ley de Oregon ORS 192.345(40)(b) exenta todas las imágenes de cámaras corporales de un agente del orden a menos que el interés público requiera su divulgación en algún caso particular.",
        PRBodyCam10: "Indique el interés público que requiera la divulgación:",
        PRBodyCam11: "Razón por la que se requiere la divulgación.",
        PRFormMedical1: "Detalle de Solicitud de los Informes de Incidentes Médicos",
        PRFormMedical2: "Nombre del paciente:",
        PRFormMedical3: "Es Obligatorio Poner el Nombre del Paciente.",
        PRFormMedical6: "Hora del Incidente: (HH:MM AM/PM)",
        PRFormMedical8: "Ubicación del Incidente:",
        PRFormMedical10: "Ubicación donde se brindó la asistencia en caso de que sea diferente a la anterior:",
        PRFormBadge: "Registros de Control del Acceso a las instalaciones / Reportes de Control de Credenciales",
        PRFormBadge1: "Envíe la solicitud de registros por separado para cada informe del titular de la credencial individual que sea necesario. No hacerlo podría retrasar el proceso o aumentar el costo de los registros solicitados.",
        PRFormBadge2: "Nombre Completo del Dueño de la Credencial:",
        PRFormBadge3: "Es obligatorio poner el nombre del dueño. de la credencial",
        PRFormBadge4: "Número de la Credencial:",
        PRFormBadge5: "Se Requiere Poner el Número de Credencial.",
        PRFormBadge6: "(en la parte superior trasera de la Credencial de seguridad de PDX)",
        PRFormBadge7: "Se requiere poner UPID.",
        PRFormBadge8: "Rango de las Fechas y Período de Tiempo de los Datos Necesarios:",
        PRFormBadge9: "Se Requiere Poner las Fechas y las Horas.",
        PRFormBadge10: "¿Cuál es el motivo de su solicitud?",
        PRFormBadge11: "Se requiere poner su respuesta.",
        PRContracts: "Detalle de la Solicitud de Ccontratos y Adquisiciones",
        PRContracts1: "Por favor visite:",
        PRContracts2: "para encontrar la Solicitud de Propuesta/Petición de Cualificación (RFP/RFQ, siglas en inglés) para su solicitud.",
        PRContracts3: "Número de RFP o RFQ: (separado por comas si se solicitan varias RFP o RFQ)",
        PRContracts4: "Título del Proyecto:",
        PRContracts5: "Es Obligatorio Poner el Título del Proyecto.",
        PRContracts6: "Registros Solicitados:",
        PRContracts7: "Todas las Propuestas/ licitaciones (se incluyen formularios SBE o DBE)",
        PRContracts8: "Propuestas/licitaciones Ganadoras (se incluyen formularios SBE o DBE)",
        PRContracts9: "Puntuación, Evaluación y notas",
        PRContracts10: "Órdenes de Tareas/Órdenes de Compra Relacionadas.",
        PRContracts11: "Contrato adjudicado",
        PROther: "Detalle de Todas las Demás Solicitudes de Registros",
        PROther1: "Describa el o los registros que usted está solicitando. Proporcione tantos detalles como sea posible, por ejemplo fecha o período de tiempo, autor, palabras clave, título o tema de los registros.",
        PROther2: "Es obligatorio poner los detalles de la solicitud.",
        PRFormReview: "Revise su Solicitud",
        PRFormReview1: "Solicite Información",
        PRFormReview7: "Para el gobierno:",
        PRFormReview8: "Para los Medios de Comunicación:",
        PRFormReview9: "Para los asuntos legales:",
        PRFormReview10: "Detalles de la Solicitud de Reportes de la Policía del Puerto de Portland",
        PRFormReview11: "Número de Caso:",
        PRFormReview12: "Nombre de la Persona Involucrada:",
        PRFormReview13: "Fecha de Nacimiento de la Persona Involucrada:",
        PRFormReview14: "Relación con la Persona Involucrada:",
        PRFormReview16: "Hora del Incidente:",
        PRFormReview18: "Detalles:",
        PRFormReview19: "Detalles de la Solicitud de Comunicaciones de Emergencia",
        PRFormReview20: "Tipos:",
        PRFormReview21: "Fecha y Hora del Incidente:",
        PRFormReview23: "Relación con el Incidente:",
        PRFormReview24: "Detalle de Solicitud de CCTV",
        PRFormReview30: "Razón:",
        PRFormReview31: "Detalles de la Solicitud de la Cámara Corporal Usada por las Fuerzas del Orden",
        PRFormReview37: "Detalles de la Solicitud de Reportes de Incidentes Médicos",
        PRFormReview38: "Nombre del Paciente:",
        PRFormReview42: "Ubicación de la Asistencia:",
        PRFormReview43: "Registros de Control de Acceso a las Instalaciones / Reportes de control de credenciales",
        PRFormReview45: "Nombre del Dueño de la Credencial:",
        PRFormReview46: "Fechas y Horas:",
        PRFormReview47: "Número de Credencial:",
        PRFormReview48: "Detalles de la Solicitud de Contratos y Adquisiciones",
        PRFormReview49: "Número de Solicitud:",
        PRFormReview50: "Títulos del Proyecto:",
        PRFormReview51: "Registros Solicitados:",
        PRFormReview52: "Detalles de Todas las Demás Solicitudes de Registros",
        PRFormReview54: "Términos y condiciones",
        PRFormReview55: "De conformidad con la Ley de Oregon ORS 192.324, los solicitantes tienen la responsabilidad de pagar las tarifas que se calculan razonablemente para reembolsar al Puerto el costo real de hacer que los registros solicitados estén disponibles. Estos costos podrían incluir el costo de buscar, localizar y copiar los registros; revisar los registros para redactar el material exento; supervisar la inspección de los registros; certificación de los registros; y envío de los registros. Se cobrarán las tarifas, aunque no se hayan localizado los registros o aunque el Puerto determine que los registros solicitados están exentos de divulgación.",
        PRFormReview56: "Puede usted ver la Lista de los Precios por Solicitar los Registros Públicos del Puerto (lista de las tarifas) visitando",
        PRFormReview57: "haciendo clic aquí",
        PRFormReview58: "Un representante del Programa de Registros del Puerto le informará sobre el costo de proporcionar los registros solicitados y requerirá su aprobación antes de comenzar a recopilarlos.",
        PRFormReview59: "AL HACER CLIC EN EL CUADRITO AQUÍ ABAJO REPRESENTA QUE USTED ESTA DE ACUERDO PARA CUMPLIR ESTOS TÉRMINOS Y CONDICIONES, incluyendo el acuerdo de pagar el costo al cumplir con esta solicitud de sus registros públicos.",
        PRFormReview60: "Acepto estos términos y condiciones.",
        PRFormReview61: "Hay al menos un error en las páginas anteriores que se debe corregir antes de enviar esta solicitud.",
        PRFormNav22: "Entregar",
        PRFormSubmitted: "Solicitud Entregada",
        PRFormSubmitted1: "Su solicitud ha sido entregada con éxito. Recibirá usted un correo electrónico de verificación muy pronto.",
        PRFormSubmitted2: "Debe usted verificar su dirección de correo electrónico haciendo clic en el botón VERIFICAR SOLICITUD contenido en ese correo electrónico.",
        PRFormSubmitted3: "No se otorgará ninguna consideración adicional a su solicitud hasta que verifique su solicitud.",
        Yes: "Sí",
    };

    return { culture, currentPage, formData, errors, lexicon, ackBox, recaptchaSiteKey, submitUrl };
});